module.exports = __webpack_public_path__ + "static/media/5DPO7.c0f727dd.jpg";